<template>
  <div>
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>授权课程</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="tableList">
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">操作日志</h3>
          <div class="panel-content">
            <el-table
              ref="multipleTable"
              :data="needData"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column
                prop="operTime"
                label="日期时间"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="actionDesc"
                label="操作类型"
                align="center"
              ></el-table-column>
              <el-table-column prop="endTime" label="操作内容" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.actionDesc=='取消授权'">权益生效到{{ scope.row.endTime | formatDate2 }}</span>
                  <span v-if="scope.row.actionDesc=='授权'">权益生效到{{ scope.row.endTime | formatDate2 }}</span>
                  <span v-if="scope.row.actionDesc == '修改授权期限'" >修改到{{ scope.row.endTime | formatDate2 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="operator" label="操作账号" align="center">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>


<script>
import { formatDate } from "@/utils/util";
export default {
  name: "doLogs",
  data() {
    return {
      logsData: [],
      getLogsData: [],
      needData: [],
    };
  },
  components: {},

  props: {},
  created() {
    let getcourseId = `${this.$route.query.id}`;
    console.log(getcourseId, "getcourseId======");
    this.fetchLogs();
  },
  computed: {},
  mounted() {},
  watch: {},
  filters: {
    formatDate2(d) {
            if(d) {
                return formatDate(d,'yyyy-MM-dd');
            }
        }
  },
  methods: {
    fetchLogs() {
      let userId=`${this.$route.query.neeId}`
      let getcourseId = `${this.$route.query.id}`;
      let params = {
        appId: this.$API.APPID,
        resourceId: Number(getcourseId),
        resourceType: 2,
        operHistory: true,
        // targetAppName: userId,
      };
      console.log(params, "params====");
      this.$axios
        .post("edu/eduAdmin/course/fyd_get_auth_list", params)
        .then((response) => {
          console.log(response, "response=======");
          this.logsData = response.data.data.list;
          for (let i = 0; i < this.logsData.length; ++i) {
            if (this.logsData[i].operHistory.length != 0) {
              this.getLogsData.push(this.logsData[i].operHistory);
            }
          }
          let newObj = this.logsData.find((ldobj) => {
            return this.$route.query.neeId == ldobj.appId;
          });
          this.needData=newObj.operHistory
          console.log(this.needData, "需要的数据");
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../fyd-style";
@import "../commonEdu";
</style>


// WEBPACK FOOTER //
// doLogs.vue?abffd586